import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, fill: "#2C69C8", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm0 3.125a.937.937 0 1 1 0 1.875.937.937 0 0 1 0-1.875Zm2.5 10.7h-5v-1.4h1.8V9.45H8.125v-1.4h2.581v5.625H12.5v1.4Z" }));
const ForwardRef = forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
